const pages = {
  auth: '/',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  home: '/home',
  intervention: {
    details: (id: number) => `/intervention/${id}/details`,
    documents: (id: string | number) => `/intervention/${id}/documents`,
    messages: {
      list: (id: string | number) => `/intervention/${id}/messages`,
      details: (id: string | number, threadId: string | number) =>
        `/intervention/${id}/messages/${threadId}`,
    },
    planning: (id: number) => `/intervention/${id}/planning`,
  },
  worker: {
    list: '/worker/list',
    create: '/worker/create',
  },
  myAccount: '/account',
  help: '/help',
};

export default pages;
